import { Component, OnInit, ViewChild } from '@angular/core';
import { StepperRecommendationComponent } from './stepper-recommendation/stepper-recommendation.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

declare const bootstrap: any;
@Component({
  selector: 'app-comparison-stepper',
  templateUrl: './comparison-stepper.component.html',
  imports: [CommonModule, FormsModule, StepperRecommendationComponent, TranslateModule],
  styleUrl: './comparison-stepper.component.scss'
})
export class ComparisonStepperComponent implements OnInit {

  @ViewChild(StepperRecommendationComponent) stepperRecommendations: StepperRecommendationComponent;

  stepButtons: NodeListOf<Element>;
  stepCards: NodeListOf<Element>;
  progress: any;

  currentStep = 0;

  citizenship: string;          // TODO move to object
  selectedCitizenship = '';
  travelDestination: string;
  havePassport: string;
  travelMethod: string;
  truckDriver: string;
  selectedAnswerStr: string;

  bestMatch = '';
  otherMatches = new Array<string>;

  stepTitles = [
    'HOME.COMPARISON_STEPPER.SELECT_CITIZENSHIP',
    'HOME.COMPARISON_STEPPER.PRIMARY_TRAVEL_DESTINATIONS',
    'HOME.COMPARISON_STEPPER.RECOMMENDED_PROGRAM'
  ];

  answerTranslationKeys = [
    'HOME.COMPARISON_STEPPER.SELECT_CITIZENSHIP',
    'HOME.COMPARISON_STEPPER.PRIMARY_TRAVEL_DESTINATIONS',
    'HOME.COMPARISON_STEPPER.RECOMMENDED_PROGRAM',
    'HOME.COMPARISON_STEPPER.STEPS.ONE.OPTION1.LABEL',
    'HOME.COMPARISON_STEPPER.STEPS.ONE.OPTION2.LABEL',
    'HOME.COMPARISON_STEPPER.STEPS.ONE.OPTION3.LABEL',
    'HOME.COMPARISON_STEPPER.STEPS.TWO.OPTION1.LABEL',
    'HOME.COMPARISON_STEPPER.STEPS.TWO.OPTION2.LABEL',
    'HOME.COMPARISON_STEPPER.STEPS.TWO.OPTION3.LABEL',
    'HOME.COMPARISON_STEPPER.STEPS.TWO.OPTION4.LABEL',
    'HOME.COMPARISON_STEPPER.HAS_PASSPORT',
    'HOME.COMPARISON_STEPPER.HAS_NO_PASSPORT',
    'HOME.COMPARISON_STEPPER.TRUCK_DRIVER',
    'HOME.COMPARISON_STEPPER.NOT_A_TRUCK_DRIVER',
    'PROGRAM_LANDING_PAGE.CITIZEN_OF'
  ];

  answerTranslatedKeys = {};

  selectedCountryTextTranslated = '';

  stepAnswers = [];

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.stepCards = document.querySelectorAll('.compCollapse');
    this.resetStepAnswers();

    this.translate.get(this.answerTranslationKeys).subscribe((res: any) => {
      this.answerTranslatedKeys = res;
    });
  }

  nextStep(): void {
    if (this.currentStep < 2) {
      this.toggleTruckDriverRadio();
      this.updateselectedAnswerStr();
      this.calculateBestMatch();
      this.stepCards.forEach(c => c.classList.remove('show'));

      this.stepCards[this.currentStep + 1].classList.add('show');
      this.currentStep++;
    }
  }

  backStep(): void {
    if (this.currentStep > 0) {
      this.toggleTruckDriverRadio();
      this.updateselectedAnswerStr();
      this.calculateBestMatch();
      this.stepCards.forEach(c => c.classList.remove('show'));

      this.stepCards[this.currentStep - 1].classList.add('show');
      this.currentStep--;
    }
  }

  updateselectedAnswerStr(): void {
    this.selectedAnswerStr = '';
    if (this.citizenship) {
      switch (this.citizenship) {
        case 'us': this.selectedAnswerStr += this.answerTranslatedKeys['HOME.COMPARISON_STEPPER.STEPS.ONE.OPTION1.LABEL'];
        break;
        case 'ca': this.selectedAnswerStr += this.answerTranslatedKeys['HOME.COMPARISON_STEPPER.STEPS.ONE.OPTION2.LABEL'];
        break;
        case 'mx': this.selectedAnswerStr += this.answerTranslatedKeys['HOME.COMPARISON_STEPPER.STEPS.ONE.OPTION3.LABEL'];
        break;
      }
    }

    if (this.citizenship === 'none') {
      if (this.selectedCitizenship) {
        this.selectedAnswerStr += ' ' + this.answerTranslatedKeys['PROGRAM_LANDING_PAGE.CITIZEN_OF'] +
          ' ' + this.selectedCountryTextTranslated;
      }
    }

    if (this.travelDestination) {
      if (this.selectedAnswerStr && this.selectedAnswerStr.length > 0) {
        this.selectedAnswerStr += ', ';
      }

      switch (this.travelDestination) {
        case 'us': this.selectedAnswerStr += this.answerTranslatedKeys['HOME.COMPARISON_STEPPER.STEPS.TWO.OPTION1.LABEL'];
        break;
        case 'ca': this.selectedAnswerStr += this.answerTranslatedKeys['HOME.COMPARISON_STEPPER.STEPS.TWO.OPTION2.LABEL'];
        break;
        case 'mx': this.selectedAnswerStr += this.answerTranslatedKeys['HOME.COMPARISON_STEPPER.STEPS.TWO.OPTION3.LABEL'];
        break;
        case 'int': this.selectedAnswerStr += this.answerTranslatedKeys['HOME.COMPARISON_STEPPER.STEPS.TWO.OPTION4.LABEL'];
        break;
      }
    }

    if (this.havePassport) {
      if (this.selectedAnswerStr && this.selectedAnswerStr.length > 0) {
        this.selectedAnswerStr += ', ';
      }

      if (this.havePassport === 'yes') {
        this.selectedAnswerStr +=  this.answerTranslatedKeys['HOME.COMPARISON_STEPPER.HAS_PASSPORT'];
      }

      if (this.havePassport === 'no') {
        this.selectedAnswerStr += this.answerTranslatedKeys['HOME.COMPARISON_STEPPER.HAS_NO_PASSPORT'];
      }
    }

    if (this.truckDriver) {
      if (this.selectedAnswerStr && this.selectedAnswerStr.length > 0) {
        this.selectedAnswerStr += ', ';
      }
  
      if (this.truckDriver === 'yes') {
        this.selectedAnswerStr += this.answerTranslatedKeys['HOME.COMPARISON_STEPPER.TRUCK_DRIVER'];
      }

      if (this.truckDriver === 'no') {
        this.selectedAnswerStr += this.answerTranslatedKeys['HOME.COMPARISON_STEPPER.NOT_A_TRUCK_DRIVER'];
      }
    }
  }

  toggleCountrySelect(country: string) : void {
    if (country !== 'none') {
      document.getElementById('select-citizenship').setAttribute('disabled', '');
      this.selectedCitizenship = '';
    } else {
      document.getElementById('select-citizenship').removeAttribute('disabled');
    }
  }

  calculateBestMatch() {
    this.bestMatch = '';
    this.otherMatches = [];

    // US
    if (this.citizenship === 'us') {
      if (this.truckDriver === 'yes') {
        this.bestMatch = 'fast';
        if (this.havePassport === 'yes') {
          this.otherMatches.push('up');
        }
        this.otherMatches.push('nh', 'sh');
      } 
      else if ( this.travelDestination === 'int') {
        if (this.havePassport === 'yes') {
          this.bestMatch = 'up';
          this.otherMatches.push('tsa', 'nh', 'sh');
        } else {
          this.bestMatch = 'tsa';
          this.otherMatches.push('nh', 'sh');
        }
      } else if (this.travelDestination === 'us') {
        this.bestMatch = 'tsa';

        if (this.havePassport === 'yes') {
          this.otherMatches.push('up');
        }
        this.otherMatches.push('nh', 'sh');
      } else if (this.travelDestination === 'ca') {
        this.bestMatch = 'nh';

        this.otherMatches.push('tsa');
        if (this.havePassport === 'yes') {
          this.otherMatches.push('up');
        }
        this.otherMatches.push('sh');
      } else if (this.travelDestination === 'mx') {
        this.bestMatch = 'sh';

        this.otherMatches.push('tsa');
        if (this.havePassport === 'yes') {
          this.otherMatches.push('up');
        }
        this.otherMatches.push('nh');
      } else {
        this.otherMatches.push('sh');
      }
    }

    // CA
    else if (this.citizenship === 'ca') {
      if (this.truckDriver === 'yes') {
        this.bestMatch = 'fast';
        this.otherMatches.push('nh', 'sh');
      } 
      else {
        this.bestMatch = 'nh';
        this.otherMatches.push('sh');
      }
    }

    // MX
    else if (this.citizenship === 'mx') {
      if (this.truckDriver === 'yes') {
        this.bestMatch = 'fast';
        if (this.havePassport === 'yes') {
          this.otherMatches.push('up');
        }
        this.otherMatches.push('nh', 'sh');
      } 
      else if ( this.travelDestination === 'int') {
        if (this.havePassport === 'yes') {
          this.bestMatch = 'up';
        } 
        this.otherMatches.push('nh', 'sh');
      } else if (this.travelDestination === 'us') {
        
        if (this.havePassport === 'yes') {
          this.bestMatch = 'up';
          this.otherMatches.push('sh', 'nh');
        } else {
          this.bestMatch = 'sh';
          this.otherMatches.push('nh');
        }
      } else if (this.travelDestination === 'ca') {
        this.bestMatch = 'nh';

        if (this.havePassport === 'yes') {
          this.otherMatches.push('up');
        }
        this.otherMatches.push('sh');
      } else if (this.travelDestination === 'mx') {
        
        if (this.havePassport === 'yes') {
          this.bestMatch = 'up';
          this.otherMatches.push('sh', 'nh');
        } else {
          this.bestMatch = 'sh';
          this.otherMatches.push('nh');
        }
      } else {
        this.otherMatches.push('sh');
      }
    }

    // Pilot Countries
    else if (this.citizenship === 'none' && this.selectedCitizenship && this.selectedCitizenship !== 'OTHER') {
      if ( this.travelDestination === 'int') {
        if (this.havePassport === 'yes') {
          this.bestMatch = 'up';
        } 
        this.otherMatches.push('sh');
      } else if (this.travelDestination === 'us') {
        
        if (this.havePassport === 'yes') {
          this.bestMatch = 'up';
        } 
        this.otherMatches.push('sh');
      } else if (this.travelDestination === 'ca') {
        if (this.havePassport === 'yes') {
          this.bestMatch = 'up';
        } 
        this.otherMatches.push('sh');
      } else if (this.travelDestination === 'mx') {
        if (this.havePassport === 'yes') {
          this.bestMatch = 'up';
        } 
        this.otherMatches.push('sh');
      } else {
        this.otherMatches.push('sh');
      }
    }

    // Other
    else if (this.citizenship === 'none' && this.selectedCitizenship && this.selectedCitizenship === 'OTHER') {
      if ( this.travelDestination === 'int') {
        this.otherMatches.push('sh');
      } else if (this.travelDestination === 'us') {
        this.otherMatches.push('sh');
      } else if (this.travelDestination === 'ca') {
          this.bestMatch = 'sh';
      } else if (this.travelDestination === 'mx') {
          this.bestMatch = 'sh';
      } else {
        this.otherMatches.push('sh');
      }
    }

    else {
      this.runDefaultComparisons();
    }

    this.stepperRecommendations.setBestMatch(this.bestMatch, this.citizenship);
    this.stepperRecommendations.setOtherOptions(this.otherMatches);
  }

  toggleTruckDriverRadio() {
    if (this.citizenship && ['us', 'mx', 'ca'].indexOf(this.citizenship) > -1) {
      document.getElementById('truckDriverYes').removeAttribute('disabled');
      document.getElementById('truckDriverNo').removeAttribute('disabled');
    } else {
      this.truckDriver = '';
      document.getElementById('truckDriverYes').setAttribute('disabled', '');
      document.getElementById('truckDriverNo').setAttribute('disabled', '');
    }
  }

  reset() {
    const element = document.querySelector('#compCollapse1');
    bootstrap.Collapse.getOrCreateInstance(element, { toggle: false }).show();

    this.currentStep = 0;

    this.citizenship = '';
    this.selectedCitizenship = '';
    this.travelDestination = '';
    this.havePassport = '';
    this.travelMethod = '';
    this.truckDriver = '';
    this.selectedAnswerStr = '';
  
    this.bestMatch = null;
    this.otherMatches = new Array<string>;
  }

  private runDefaultComparisons() {

    if (!this.travelDestination) {
      this.otherMatches.push('tsa');

      if (this.havePassport === 'yes') {
        this.otherMatches.push('up');
      }
      this.otherMatches.push('sh');
      this.otherMatches.push('nh');
    }
  }

  private resetStepAnswers() {
    this.stepAnswers = [
      {
        citizenship: undefined,
        selectedCitizenship: '',
        valid: false
      },
      {
        travelDestination: undefined,
        hasPassport: undefined,
        valid: false
      },
      {
        travelMethods: [],
        isTruckDriver: undefined
      }
    ];
  }

  public isCurrentStepValid(): boolean {
    if (this.currentStep === 0 && 
      ((['us', 'ca', 'mx'].indexOf(this.citizenship) > -1 || 
        (this.citizenship === 'none' && this.selectedCitizenship)))) {
      return true;
    } else if (this.currentStep === 1 && this.travelDestination && this.havePassport) {
      return true;
    } else if (this.currentStep === 2) {
        if (['us', 'ca', 'mx'].indexOf(this.citizenship) > -1) {
          if (this.truckDriver) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
    } else {
      return false;
    }
  }

  public setSelectedText(event: any) {
    this.selectedCountryTextTranslated = event.target.options[event.target.selectedIndex].text;
  }

  public initTranslationKeys() {
    this.translate.get(this.answerTranslationKeys).subscribe((res: any) => {
      this.answerTranslatedKeys = res;
    });
  }
}
